import type { RouteObject } from 'react-router';
import { MarketPage } from './pages/MarketPage';
import { GeeCoinPage } from './pages/GeeCoinPage';

export const marketRoutes: RouteObject[] = [
  { path: 'market', element: <MarketPage /> },
  { path: 'geecoin', element: <GeeCoinPage /> },
];
